export const PATHS = {
  home: '/',
  about: '/about',
  paul: '/paul-lin',
  blog: '/blog',
  blogPost: '/blog/:slug',
  humanAiProject: '/human-ai-project',
  research: '/research',
  terms: '/terms',
  privacy: '/privacy',
  careers: '/careers',
} as const
